/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    PaginatedWatchlistSymbolDto,
    PaginatedWatchlistSymbolDtoFromJSON,
    PaginatedWatchlistSymbolDtoToJSON,
    RecalculateSymbolDto,
    RecalculateSymbolDtoFromJSON,
    RecalculateSymbolDtoToJSON,
    SymbolCloseChartDto,
    SymbolCloseChartDtoFromJSON,
    SymbolCloseChartDtoToJSON,
    SymbolDto,
    SymbolDtoFromJSON,
    SymbolDtoToJSON,
    SymbolFundamentalDataDto,
    SymbolFundamentalDataDtoFromJSON,
    SymbolFundamentalDataDtoToJSON,
    SymbolFundamentalsAvailableAttributesDto,
    SymbolFundamentalsAvailableAttributesDtoFromJSON,
    SymbolFundamentalsAvailableAttributesDtoToJSON,
    SymbolFundamentalsRatiosDto,
    SymbolFundamentalsRatiosDtoFromJSON,
    SymbolFundamentalsRatiosDtoToJSON,
    SymbolFundamentalsRatiosHistoryDto,
    SymbolFundamentalsRatiosHistoryDtoFromJSON,
    SymbolFundamentalsRatiosHistoryDtoToJSON,
    SymbolFundamentalsTimeSeriesDto,
    SymbolFundamentalsTimeSeriesDtoFromJSON,
    SymbolFundamentalsTimeSeriesDtoToJSON,
    SymbolHistoryCloseDto,
    SymbolHistoryCloseDtoFromJSON,
    SymbolHistoryCloseDtoToJSON,
    SymbolWithExchangeAndReferenceSymbolDto,
    SymbolWithExchangeAndReferenceSymbolDtoFromJSON,
    SymbolWithExchangeAndReferenceSymbolDtoToJSON,
    WatchlistSymbolListSortDto,
    WatchlistSymbolListSortDtoFromJSON,
    WatchlistSymbolListSortDtoToJSON,
} from '../models';

export interface SymbolControllerGetAvailableAttributesRequest {
    symbolId: string;
    periodType?: SymbolControllerGetAvailableAttributesPeriodTypeEnum;
}

export interface SymbolControllerGetBySymbolAndExchangeRequest {
    exchange: string;
    symbol: string;
}

export interface SymbolControllerGetFromWatchlistRequest {
    limit: number;
    offset: number;
    watchlistId: string;
    phrase?: string;
    sort?: WatchlistSymbolListSortDto;
}

export interface SymbolControllerGetFundamentalIdRequest {
    exchangeId: string;
    symbol: string;
}

export interface SymbolControllerGetListRequest {
    phrase: string;
    limit: number;
    watchlistId?: string;
}

export interface SymbolControllerGetRatiosRequest {
    symbolId: string;
}

export interface SymbolControllerGetRatiosHistoryRequest {
    symbolId: string;
}

export interface SymbolControllerGetSymbolHistoryByIdRequest {
    exchangeId: string;
    symbol: string;
    dateFrom?: string;
}

export interface SymbolControllerGetSymbolHistoryByIdAndDateRequest {
    symbolId: string;
    date: string;
}

export interface SymbolControllerGetTimeSeriesRequest {
    symbolId: string;
    attributeKey: string;
    periodType?: SymbolControllerGetTimeSeriesPeriodTypeEnum;
}

export interface SymbolControllerRecalculateSymbolDataRequest {
    recalculateSymbolDto: RecalculateSymbolDto;
}

/**
 * 
 */
export class SymbolsApi extends runtime.BaseAPI {

    /**
     */
    async symbolControllerGetAvailableAttributesRaw(requestParameters: SymbolControllerGetAvailableAttributesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SymbolFundamentalsAvailableAttributesDto>> {
        if (requestParameters.symbolId === null || requestParameters.symbolId === undefined) {
            throw new runtime.RequiredError('symbolId','Required parameter requestParameters.symbolId was null or undefined when calling symbolControllerGetAvailableAttributes.');
        }

        const queryParameters: any = {};

        if (requestParameters.periodType !== undefined) {
            queryParameters['periodType'] = requestParameters.periodType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/symbols/{symbolId}/fundamentals`.replace(`{${"symbolId"}}`, encodeURIComponent(String(requestParameters.symbolId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SymbolFundamentalsAvailableAttributesDtoFromJSON(jsonValue));
    }

    /**
     */
    async symbolControllerGetAvailableAttributes(requestParameters: SymbolControllerGetAvailableAttributesRequest, initOverrides?: RequestInit): Promise<SymbolFundamentalsAvailableAttributesDto> {
        const response = await this.symbolControllerGetAvailableAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get symbol by symbol and exchange
     */
    async symbolControllerGetBySymbolAndExchangeRaw(requestParameters: SymbolControllerGetBySymbolAndExchangeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SymbolWithExchangeAndReferenceSymbolDto>> {
        if (requestParameters.exchange === null || requestParameters.exchange === undefined) {
            throw new runtime.RequiredError('exchange','Required parameter requestParameters.exchange was null or undefined when calling symbolControllerGetBySymbolAndExchange.');
        }

        if (requestParameters.symbol === null || requestParameters.symbol === undefined) {
            throw new runtime.RequiredError('symbol','Required parameter requestParameters.symbol was null or undefined when calling symbolControllerGetBySymbolAndExchange.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/symbols/{exchange}/{symbol}`.replace(`{${"exchange"}}`, encodeURIComponent(String(requestParameters.exchange))).replace(`{${"symbol"}}`, encodeURIComponent(String(requestParameters.symbol))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SymbolWithExchangeAndReferenceSymbolDtoFromJSON(jsonValue));
    }

    /**
     * Get symbol by symbol and exchange
     */
    async symbolControllerGetBySymbolAndExchange(requestParameters: SymbolControllerGetBySymbolAndExchangeRequest, initOverrides?: RequestInit): Promise<SymbolWithExchangeAndReferenceSymbolDto> {
        const response = await this.symbolControllerGetBySymbolAndExchangeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get symbols from watchlist
     */
    async symbolControllerGetFromWatchlistRaw(requestParameters: SymbolControllerGetFromWatchlistRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PaginatedWatchlistSymbolDto>> {
        if (requestParameters.limit === null || requestParameters.limit === undefined) {
            throw new runtime.RequiredError('limit','Required parameter requestParameters.limit was null or undefined when calling symbolControllerGetFromWatchlist.');
        }

        if (requestParameters.offset === null || requestParameters.offset === undefined) {
            throw new runtime.RequiredError('offset','Required parameter requestParameters.offset was null or undefined when calling symbolControllerGetFromWatchlist.');
        }

        if (requestParameters.watchlistId === null || requestParameters.watchlistId === undefined) {
            throw new runtime.RequiredError('watchlistId','Required parameter requestParameters.watchlistId was null or undefined when calling symbolControllerGetFromWatchlist.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.phrase !== undefined) {
            queryParameters['phrase'] = requestParameters.phrase;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/symbols/watchlist/{watchlistId}`.replace(`{${"watchlistId"}}`, encodeURIComponent(String(requestParameters.watchlistId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedWatchlistSymbolDtoFromJSON(jsonValue));
    }

    /**
     * Get symbols from watchlist
     */
    async symbolControllerGetFromWatchlist(requestParameters: SymbolControllerGetFromWatchlistRequest, initOverrides?: RequestInit): Promise<PaginatedWatchlistSymbolDto> {
        const response = await this.symbolControllerGetFromWatchlistRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get symbol fundamental data by symbolId
     */
    async symbolControllerGetFundamentalIdRaw(requestParameters: SymbolControllerGetFundamentalIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SymbolFundamentalDataDto>> {
        if (requestParameters.exchangeId === null || requestParameters.exchangeId === undefined) {
            throw new runtime.RequiredError('exchangeId','Required parameter requestParameters.exchangeId was null or undefined when calling symbolControllerGetFundamentalId.');
        }

        if (requestParameters.symbol === null || requestParameters.symbol === undefined) {
            throw new runtime.RequiredError('symbol','Required parameter requestParameters.symbol was null or undefined when calling symbolControllerGetFundamentalId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/symbols/{exchangeId}/{symbol}/fundamental-data`.replace(`{${"exchangeId"}}`, encodeURIComponent(String(requestParameters.exchangeId))).replace(`{${"symbol"}}`, encodeURIComponent(String(requestParameters.symbol))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SymbolFundamentalDataDtoFromJSON(jsonValue));
    }

    /**
     * Get symbol fundamental data by symbolId
     */
    async symbolControllerGetFundamentalId(requestParameters: SymbolControllerGetFundamentalIdRequest, initOverrides?: RequestInit): Promise<SymbolFundamentalDataDto> {
        const response = await this.symbolControllerGetFundamentalIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get symbols by phrase
     */
    async symbolControllerGetListRaw(requestParameters: SymbolControllerGetListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<SymbolDto>>> {
        if (requestParameters.phrase === null || requestParameters.phrase === undefined) {
            throw new runtime.RequiredError('phrase','Required parameter requestParameters.phrase was null or undefined when calling symbolControllerGetList.');
        }

        if (requestParameters.limit === null || requestParameters.limit === undefined) {
            throw new runtime.RequiredError('limit','Required parameter requestParameters.limit was null or undefined when calling symbolControllerGetList.');
        }

        const queryParameters: any = {};

        if (requestParameters.phrase !== undefined) {
            queryParameters['phrase'] = requestParameters.phrase;
        }

        if (requestParameters.watchlistId !== undefined) {
            queryParameters['watchlistId'] = requestParameters.watchlistId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/symbols`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SymbolDtoFromJSON));
    }

    /**
     * Get symbols by phrase
     */
    async symbolControllerGetList(requestParameters: SymbolControllerGetListRequest, initOverrides?: RequestInit): Promise<Array<SymbolDto>> {
        const response = await this.symbolControllerGetListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get fundamentals ratios for a symbol
     */
    async symbolControllerGetRatiosRaw(requestParameters: SymbolControllerGetRatiosRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SymbolFundamentalsRatiosDto>> {
        if (requestParameters.symbolId === null || requestParameters.symbolId === undefined) {
            throw new runtime.RequiredError('symbolId','Required parameter requestParameters.symbolId was null or undefined when calling symbolControllerGetRatios.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/symbols/{symbolId}/fundamentals/ratios`.replace(`{${"symbolId"}}`, encodeURIComponent(String(requestParameters.symbolId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SymbolFundamentalsRatiosDtoFromJSON(jsonValue));
    }

    /**
     * Get fundamentals ratios for a symbol
     */
    async symbolControllerGetRatios(requestParameters: SymbolControllerGetRatiosRequest, initOverrides?: RequestInit): Promise<SymbolFundamentalsRatiosDto> {
        const response = await this.symbolControllerGetRatiosRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get historical ratios for a symbol
     */
    async symbolControllerGetRatiosHistoryRaw(requestParameters: SymbolControllerGetRatiosHistoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SymbolFundamentalsRatiosHistoryDto>> {
        if (requestParameters.symbolId === null || requestParameters.symbolId === undefined) {
            throw new runtime.RequiredError('symbolId','Required parameter requestParameters.symbolId was null or undefined when calling symbolControllerGetRatiosHistory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/symbols/{symbolId}/fundamentals/ratios/history`.replace(`{${"symbolId"}}`, encodeURIComponent(String(requestParameters.symbolId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SymbolFundamentalsRatiosHistoryDtoFromJSON(jsonValue));
    }

    /**
     * Get historical ratios for a symbol
     */
    async symbolControllerGetRatiosHistory(requestParameters: SymbolControllerGetRatiosHistoryRequest, initOverrides?: RequestInit): Promise<SymbolFundamentalsRatiosHistoryDto> {
        const response = await this.symbolControllerGetRatiosHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get symbol value history by symbolId
     */
    async symbolControllerGetSymbolHistoryByIdRaw(requestParameters: SymbolControllerGetSymbolHistoryByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SymbolCloseChartDto>> {
        if (requestParameters.exchangeId === null || requestParameters.exchangeId === undefined) {
            throw new runtime.RequiredError('exchangeId','Required parameter requestParameters.exchangeId was null or undefined when calling symbolControllerGetSymbolHistoryById.');
        }

        if (requestParameters.symbol === null || requestParameters.symbol === undefined) {
            throw new runtime.RequiredError('symbol','Required parameter requestParameters.symbol was null or undefined when calling symbolControllerGetSymbolHistoryById.');
        }

        const queryParameters: any = {};

        if (requestParameters.dateFrom !== undefined) {
            queryParameters['dateFrom'] = requestParameters.dateFrom;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/symbols/{exchangeId}/{symbol}/fundamental-data/value-history`.replace(`{${"exchangeId"}}`, encodeURIComponent(String(requestParameters.exchangeId))).replace(`{${"symbol"}}`, encodeURIComponent(String(requestParameters.symbol))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SymbolCloseChartDtoFromJSON(jsonValue));
    }

    /**
     * Get symbol value history by symbolId
     */
    async symbolControllerGetSymbolHistoryById(requestParameters: SymbolControllerGetSymbolHistoryByIdRequest, initOverrides?: RequestInit): Promise<SymbolCloseChartDto> {
        const response = await this.symbolControllerGetSymbolHistoryByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get symbol history by symbolId and date
     */
    async symbolControllerGetSymbolHistoryByIdAndDateRaw(requestParameters: SymbolControllerGetSymbolHistoryByIdAndDateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SymbolHistoryCloseDto>> {
        if (requestParameters.symbolId === null || requestParameters.symbolId === undefined) {
            throw new runtime.RequiredError('symbolId','Required parameter requestParameters.symbolId was null or undefined when calling symbolControllerGetSymbolHistoryByIdAndDate.');
        }

        if (requestParameters.date === null || requestParameters.date === undefined) {
            throw new runtime.RequiredError('date','Required parameter requestParameters.date was null or undefined when calling symbolControllerGetSymbolHistoryByIdAndDate.');
        }

        const queryParameters: any = {};

        if (requestParameters.date !== undefined) {
            queryParameters['date'] = requestParameters.date;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/symbols/{symbolId}/symbol-history-by-date`.replace(`{${"symbolId"}}`, encodeURIComponent(String(requestParameters.symbolId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SymbolHistoryCloseDtoFromJSON(jsonValue));
    }

    /**
     * Get symbol history by symbolId and date
     */
    async symbolControllerGetSymbolHistoryByIdAndDate(requestParameters: SymbolControllerGetSymbolHistoryByIdAndDateRequest, initOverrides?: RequestInit): Promise<SymbolHistoryCloseDto> {
        const response = await this.symbolControllerGetSymbolHistoryByIdAndDateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get time series data for a fundamental attribute
     */
    async symbolControllerGetTimeSeriesRaw(requestParameters: SymbolControllerGetTimeSeriesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SymbolFundamentalsTimeSeriesDto>> {
        if (requestParameters.symbolId === null || requestParameters.symbolId === undefined) {
            throw new runtime.RequiredError('symbolId','Required parameter requestParameters.symbolId was null or undefined when calling symbolControllerGetTimeSeries.');
        }

        if (requestParameters.attributeKey === null || requestParameters.attributeKey === undefined) {
            throw new runtime.RequiredError('attributeKey','Required parameter requestParameters.attributeKey was null or undefined when calling symbolControllerGetTimeSeries.');
        }

        const queryParameters: any = {};

        if (requestParameters.periodType !== undefined) {
            queryParameters['periodType'] = requestParameters.periodType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/symbols/{symbolId}/fundamentals/{attributeKey}`.replace(`{${"symbolId"}}`, encodeURIComponent(String(requestParameters.symbolId))).replace(`{${"attributeKey"}}`, encodeURIComponent(String(requestParameters.attributeKey))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SymbolFundamentalsTimeSeriesDtoFromJSON(jsonValue));
    }

    /**
     * Get time series data for a fundamental attribute
     */
    async symbolControllerGetTimeSeries(requestParameters: SymbolControllerGetTimeSeriesRequest, initOverrides?: RequestInit): Promise<SymbolFundamentalsTimeSeriesDto> {
        const response = await this.symbolControllerGetTimeSeriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Recalculate symbol data
     */
    async symbolControllerRecalculateSymbolDataRaw(requestParameters: SymbolControllerRecalculateSymbolDataRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.recalculateSymbolDto === null || requestParameters.recalculateSymbolDto === undefined) {
            throw new runtime.RequiredError('recalculateSymbolDto','Required parameter requestParameters.recalculateSymbolDto was null or undefined when calling symbolControllerRecalculateSymbolData.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/symbols/recalculate-symbol`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RecalculateSymbolDtoToJSON(requestParameters.recalculateSymbolDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Recalculate symbol data
     */
    async symbolControllerRecalculateSymbolData(requestParameters: SymbolControllerRecalculateSymbolDataRequest, initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.symbolControllerRecalculateSymbolDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum SymbolControllerGetAvailableAttributesPeriodTypeEnum {
    Quarterly = 'quarterly',
    Yearly = 'yearly'
}
/**
    * @export
    * @enum {string}
    */
export enum SymbolControllerGetTimeSeriesPeriodTypeEnum {
    Quarterly = 'quarterly',
    Yearly = 'yearly'
}
